module.exports = __webpack_public_path__ + "img/JAC-background.dd45fbe8.jpg";